<script>
    import AppIcon from "./icons/AppIcon.svelte";

    export let searchCallBack;
    export let clearCallback;
</script>

<div class="d-flex align-items-center">
    <button class="btn btn-primary btn-block btn-normal me-1" on:click={ () => searchCallBack() }>
        <AppIcon icon="search"/>
    </button>
    <button class="btn btn-default btn-block btn-normal ms-1" on:click={ () => clearCallback() }>
        <AppIcon icon="x" strokeWidth="2"/>
    </button>
</div>